import { css } from 'emotion';

import { colors, fonts } from '../styles';

export const upsellTooltipTitle = css`
  display: flex;
  justify-content: space-between;
  align-items: center;

  color: ${colors.black};
  font-size: ${fonts.size.medium};
  font-weight: ${fonts.weight.medium};
  margin-bottom: 10px;
`;

export const upsellTooltipText = css`
  margin-bottom: 20px;
`;

export const upsellTooltip = css`
  width: 207px;

  > button {
    width: 100%;
  }
`;
